import React, {Component} from "react";
import DataTable from "react-data-table-component";
import {connect} from "react-redux";
import {NavLink as Links} from "react-router-dom";
import {AccountGroups, AccountHeads,} from "../../../../redux/actions/Modules.Action";
import ApiConnect from "../../../../Utils/ApiConnect";

class AccountHeadDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      myFData: [],
      btnDisable: false,
      filterText: "",
    };
    this.columns = [
      {
        name: "Account Head",
        selector: row => row.name,
        cell: (row) => {
          return (
            <React.Fragment>
              {row.name}
              <small> {row.group}</small>
            </React.Fragment>
          );
        },
      },
      {
        name: "Limit",
        selector: row => row.limit,
        sortable: true,
      },
      {
        name: "Balance",
        selector: row => row.balance,
        sortable: true,
      },
      {
        name: "PAN/VAT",
        selector: row => row.vat,
        sortable: true,
      },
      {
        name: "Address",
        selector: row => row.address,
      },
      {
        name: "Contact",
        selector: row => row.contact,
        sortable: true,
      },
      {
        name: "E-mail",
        selector: row => row.mail,
      },
      {
        name: "Action",
        selector: row => row.action,
        className: "table-actions",
        width: "150px",

        cell: (row) => {
          return (
            <React.Fragment>
              <button className="table-action btn btn-square btn-pure hover-warning">
                <span className="material-icons-outlined">edit_note</span>
              </button>
              <button className="table-action btn btn-square btn-pure hover-danger">
                <span className="material-icons-outlined">delete</span>
              </button>
              <Links
                to={`${this.props.location.pathname}/View/${row.id}`}
                className="table-action btn btn-square btn-pure hover-success"
              >
                <span className="material-icons-outlined">visibility</span>
              </Links>
            </React.Fragment>
          );
        },
      },
      ];
  }

  customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };

  componentDidMount() {
    this.fetchAccountDetails();
  }
  fetchAccountDetails() {
    ApiConnect.get("/Module/Accounts/AccountHead/Details")
      .then((response) => {
        this.props.AccountHeads(response.data);
      })
      .catch((error) => console.log(error));
  }

  render() {
    const filteredData = this.props.AccountHeadData.filter(item =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(this.state.filterText.toLowerCase())
      )
    );
    return (
      <>
        <div className="dataTables_wrapper">
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search..."
              onChange={e => this.setState({ filterText: e.target.value })}
            />
          </div>
          <DataTable
            className="table table-separated"
            keyField="id"
            columns={this.columns}
            data={filteredData}
            pagination
            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
            paginationPerPage={10}
            customStyles={this.customStyles}
            filter
            exportable
          />
        </div>
      </>
    );
  }
}
export default connect(
  (state) => ({
    AccountHeadData: state.Accounts.AccountHead,
    AccountGroupData: state.Accounts.AccountGroup,
  }),
  { AccountHeads, AccountGroups }
)(AccountHeadDetails);
